var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0274 7.08904C17.0274 4.7617 15.1286 2.875 12.7862 2.875C10.4438 2.875 8.54495 4.7617 8.54495 7.08904C8.54495 9.41639 10.4438 11.3031 12.7862 11.3031C15.1285 11.3031 17.0274 9.41639 17.0274 7.08904Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54654 19.2017C4.47918 19.5532 4.74723 19.875 5.10729 19.875L14.0445 19.8749L17.5398 13.9038C16.1887 12.9788 14.5511 12.4372 12.7862 12.4372C8.69347 12.4372 5.28572 15.3494 4.54654 19.2017Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9111 24.1247L15.1603 21.4076L17.1586 22.5774L14.9111 24.1247Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3831 9.875L24.2138 11.532L18.4275 21.417L15.5968 19.76L21.3831 9.875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.4291a17380be5c94bfba6038d89f906f.svg";
export { ForwardRef as ReactComponent };